import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GetUserCardInfo } from '../services/@types/user-personal-data';
import { parseBoolean } from '@shared/helpers/parse-boolean';

const initialState: GetUserCardInfo = {} as GetUserCardInfo;

const userCard = createSlice({
  name: 'userCard',
  initialState,
  reducers: {
    setUserCard(state, { payload }: PayloadAction<GetUserCardInfo>) {
      state = {
        ...payload,
        isBlock: parseBoolean(payload.isBlock) || false,
      };

      return state;
    },
    clearUserCard() {
      return {} as GetUserCardInfo;
    },
  },
});

export const { setUserCard, clearUserCard } = userCard.actions;

export default userCard.reducer;
